import CustomInput from 'reactstrap/es/CustomInput';
import Button from 'reactstrap/es/Button';
import { useLocalStorage } from '@yooink/youtils/es/hooks/useLocalStorage';
import {Block} from "@yooink/youi/dist/Layout/Block";
import {Header} from "@yooink/youi/dist/Layout/Header";

const UISettings = () => {
	const [darkTheme, setDarkTheme] = useLocalStorage('isDarkTheme', false);
	const [theme, setTheme] = useLocalStorage('themeName', 'pilgrim');

    return (
	<Block>
		<Header title={'UI Settings'}/>
		<CustomInput
			type="checkbox"
			label="Dark theme"
			onChange={(e) => setDarkTheme(e.target.checked)}
			checked={darkTheme}
			id="DarkTheme"
		/>
		<h4 className="subtitle">Theme</h4>
		<div style={{ display: 'flex' }}>
			{
				['yoink', 'pilgrim'].map((e) => (
					<Button
						onClick={() => setTheme(e)}
						color={theme === e ? 'success' : 'secondary'}
					>
						{e}
					</Button>
				))
			}
		</div>
	</Block>
    );
};

export default UISettings;
